import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const ConfigContext = createContext();

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ empresa_nome: 'OvinoGest', cor_primaria: '#2D6A4F', cor_secundaria: '#40916C', tema: 'light', fonte: 'Roboto', tamanho_fonte: 'normal' });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const { data } = await api.get('/configuracoes');
      setConfig(data);
      applyTheme(data);
    } catch {}
  };

  const applyTheme = (cfg) => {
    const r = document.documentElement;
    r.style.setProperty('--color-primary', cfg.cor_primaria || '#2D6A4F');
    r.style.setProperty('--color-secondary', cfg.cor_secundaria || '#40916C');
    r.style.setProperty('--font-family', cfg.fonte || 'Roboto');
    document.body.style.fontFamily = `'${cfg.fonte || 'Roboto'}', sans-serif`;
    document.body.setAttribute('data-theme', cfg.tema || 'light');

    // Escala de fonte configurável
    const escalas = { pequena: '0.9', normal: '1', grande: '1.15', extra_grande: '1.3' };
    const escala = escalas[cfg.tamanho_fonte] || '1';
    r.style.setProperty('--font-scale', escala);
  };

  return <ConfigContext.Provider value={{ config, loadConfig, applyTheme }}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
